import { useState } from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';
import * as Recharts from "recharts/umd/Recharts";
import { Button, Card, Label, InputGroup, Divider, Collapse } from '@blueprintjs/core';
import { Navbar, Alignment } from '@blueprintjs/core';
import adexstate from './adexstate';

import _ from 'underscore';
import './App.css';
import { DIVIDER } from '@blueprintjs/core/lib/esm/common/classes';
import amritalogo from './Amritalogo.png';
import vlablogo from './vlablogo2.jpg'

// test 
const LineChart = Recharts.LineChart
const Line = Recharts.Line
const Cell = Recharts.Cell
const XAxis = Recharts.XAxis
const YAxis = Recharts.YAxis
const CartesianGrid = Recharts.CartesianGrid
const Tooltip = Recharts.Tooltip
const Legend = Recharts.Legend
const ResponsiveContainer = Recharts.ResponsiveContainer;

class AdexNeuron {
  constructor (state) {
    console.log(state)
    this.C = state.C;
    this.el = state.el;
    this.del = state.del;
    this.a = state.a;
    this.vr = state.vr;
    this.gl = state.gl;
    this.vt = state.vt;
    this.tw = state.tw;
    this.b = state.b;
    this.dt = 0.1;

    // this.T = 100;
    // this.I = 20;
  }

  run(V,w,I){
    const dV = this.dt * (this.gl * (V - this.el) + (this.gl * this.del * Math.exp((V - this.vt) / this.del)) - w + I) / this.C;
    const dw = this.dt * ((this.a * (V - this.el) - w) / this.tw);
    return [dV, dw]
  }
}

class SimpleSynapse{
  constructor(nNeurons, I){
    this.I = I
    this.w = new Array(nNeurons).fill(0).map( (w, wi) => wi === 0 ? I : 5 )
  }


  // calI = (ni) => ni === 0 ? this.w[ni] : prev_nV === 0 ? this.inW(ni) : this.w[ni] 

  upI = (ni) => this.w[ni] = this.w[ni]+ (5+ni+1)
}


function App() {
    const [state, setState] = useState(adexstate.adex_modes_list.default);
    const [modesWindowState, setmodesWindowState] = useState('default');

    const [ nNeurons, setnNeurons ] = useState(5);
    const [neurons, setNeurons] = useState([]);
    const [plotData, setplotData] = useState([]);
    const [AVPData, setAVPData] = useState([]);
    const [modelParameterWindowState, setmodelParameterWindowState] = useState(true);
    const [networkParametersWindowState, setnetworkParametersWindowState] = useState(false);

    const [rawData, setRawData ] = useState([]);

    const changeMode = (mode) => {
      console.log(adexstate.adex_modes_list[mode])
      setState(adexstate.adex_modes_list[mode])
    }


    const changeState = (name, value) => {
      setState({
        ...state,
        [name]: parseFloat(value),
      })
    }
    const changenNeurons = (value) => {
      setnNeurons(parseFloat(value));
    }


    const createNeurons = () => {
      const neu = _.range(nNeurons).map(n => new AdexNeuron(state));
      // const syn = _.range(nNeurons).map((n,i) => [0])
      // nV = _.range(nNeurons).map((n,i) => [neu[i].el])
      // nw = _.range(nNeurons).map(n => [0])
      setNeurons(neu);
    }

    const simRun = () => {
      const T = 500;
      const dt = 0.1;
      const nSteps = T / dt;
      const I = new Array(nSteps).fill(0); //generateCurrent(3,dt); //input current

      const syn =  new SimpleSynapse(nNeurons, 20);

      let nV = _.range(nNeurons).map((n,i) => [neurons[i].el])
      let nw = _.range(nNeurons).map(n => [0])
      const fired_neurons = [];

      // let dV = 0;
      // let dw = 0;
      let T_steps = [0];

      for(let i =0; i< nSteps; i++){
        const nouts = neurons.map((n,ni) => n.run(nV[ni][i], nw[ni][i], syn.w[ni] ));
        nouts.forEach((no,ni)=> {nV[ni].push(nV[ni][i]+no[0]); nw[ni].push(nw[ni][i]+no[1])})

        T_steps.push(T_steps[i]+dt)
        nV.forEach( (nv, ni) => nv[i+1] > 0 ? ( syn.upI(ni), nV[ni][i] = 0, nw[ni][i+1]= nw[ni][i]+neurons[ni].b, nV[ni][i+1]= neurons[ni].el ): (0) )

        // fired_neurons.push(nouts.map(v=> v[0]=== 0 ? 1 : 0))

      }

      // setplotData(T_steps.map((t,ti)=> nV.map((nv,ni) => ({ 'time': t, 'v': nv[ti], 'w': nw[ni][ti] }))));
      // setplotData(nV.map((nv, ni) => T_steps.map((t, ti) => ({ 'time': t, 'v': nv[ti], 'w': nw[ni][ti] })) )[0])
      let plot_data = []
      setRawData(nV);
      T_steps.forEach((t, ti) => {
        let tmp_inst = {}
        tmp_inst['t'] = t;
        nV.forEach((nv, ni) => tmp_inst['n'+ni] = nv[ti])
        plot_data.push(tmp_inst);
      })
      setplotData(plot_data)

    }


  return (
    <div className="App bp3-dark" style={{ margin: "0 auto", width: '80%', height:'100%' }}>
      <Navbar>
        <Navbar.Heading align={Alignment.LEFT} >Amrita Neuron Network Simulator</Navbar.Heading>
      </Navbar>
      <Grid fluid>
          <Card>
          <Row>
          <Col md={8}>
          <ResponsiveContainer >
          <LineChart  data={plotData}> 
                <CartesianGrid horizontal={false} vertical={false} />
                <XAxis dataKey="time" />
                <YAxis />
                <Tooltip />
                <Legend />
                {
                  neurons.map((nv,ni)=> <Line type="monotone" dataKey={"n"+ni} stroke="#8884d8" dot={false} /> )
                }
            </LineChart>
            </ResponsiveContainer>

          </Col>
          
          <Col md={4}>
            <Card>
              <Button onClick={()=>setmodelParameterWindowState(!modelParameterWindowState)}  text='Model Parameters'/>
              <Collapse isOpen={modelParameterWindowState}>
              <Card>
                                    <Grid>
                                        <Row>
                                            <Col md={3}><Label>C :</Label></Col>
                                            <Col md={3}>
                                                <InputGroup  fill={false} small  value={state.C} onChange={(e)=> changeState('C', e.target.value)} />
                                            </Col>
                                            <Col md={3}><Label>T : </Label></Col>
                                            <Col md={3}><InputGroup  fill={false} small value={state.T} onChange={(e)=> changeState('T', e.target.value)} /></Col>
                                        </Row>
                                    </Grid>
                                    <Grid>
                                        <Row>
                                            <Col md={3}><Label>gl :</Label></Col>
                                            <Col md={3}>
                                                <InputGroup  fill={false} small value={state.gl} onChange={(e)=> changeState('gl', e.target.value)} />
                                            </Col>
                                            <Col md={3}><Label>el : </Label></Col>
                                            <Col md={3}><InputGroup  fill={false} small value={state.el} onChange={(e)=> changeState('el', e.target.value)} /></Col>
                                        </Row>
                                    </Grid>
                                    <Grid>
                                        <Row>
                                            <Col md={3}><Label>vt :</Label></Col>
                                            <Col md={3}>
                                                <InputGroup  fill={false} small value={state.vt} onChange={(e)=> changeState('vt', e.target.value)} />
                                            </Col>
                                            <Col md={3}><Label>del : </Label></Col>
                                            <Col md={3}><InputGroup  fill={false} small value={state.del} onChange={(e)=> changeState('del', e.target.value)} /></Col>
                                        </Row>
                                    </Grid>
                                    <Grid>
                                        <Row>
                                            <Col md={3}><Label>tw :</Label></Col>
                                            <Col md={3}>
                                                <InputGroup  fill={false} small value={state.tw} onChange={(e)=> changeState('tw', e.target.value)} />
                                            </Col>
                                            <Col md={3}><Label>vr : </Label></Col>
                                            <Col md={3}><InputGroup  fill={false} small  value={state.vr} onChange={(e)=> changeState('vr', e.target.value)} /></Col>
                                        </Row>
                                    </Grid>
                                    <Grid>
                                        <Row>
                                            <Col md={3}><Label>a :</Label></Col>
                                            <Col md={3}>
                                                <InputGroup  fill={false} small value={state.a} onChange={(e)=> changeState('a', e.target.value)} />
                                            </Col>
                                            <Col md={3}><Label>b : </Label></Col>
                                            <Col md={3}><InputGroup  fill={false} small value={state.b} onChange={(e)=> changeState('b', e.target.value)} /></Col>
                                        </Row>
                                    </Grid>
                                    <Grid>
                                        <Row>
                                            <Col md={3}><Label>I :</Label></Col>
                                            <Col md={3}>
                                                <InputGroup  fill={false} small value={state.I} onChange={(e)=> changeState('I', e.target.value)} />
                                            </Col>
                                            <Col md={3}><Label> </Label></Col>
                                            <Col md={3}><InputGroup  fill={false} small  disabled/></Col>
                                        </Row>
                                    </Grid>
                                </Card>
                  
              </Collapse>
              <Divider />

              <Card>
        <Button onClick={()=> setmodesWindowState(!modesWindowState)} text='Modes' />
        <Collapse isOpen={modesWindowState}>
            <Card>
                <div>
                    {Object.keys(adexstate.adex_modes_list).map((m,i) => (<Button onClick={()=> changeMode(m)} style={{ marginRight: '8px' }}>{m}</Button>))}
                </div>

            </Card>
        </Collapse>

        <Divider vertical />
              <Button onClick={()=> setnetworkParametersWindowState(!networkParametersWindowState)}> Network Parameters </Button>
              <Collapse isOpen={networkParametersWindowState}>
              <Grid>
                <Row>
                    <Col md={3}><Label>Number of Neurons :</Label></Col>
                    <Col md={3}>
                        <InputGroup fill={false} small  value={nNeurons} onChange={(e)=> changenNeurons(e.target.value)} />
                    </Col>
                </Row>
              </Grid>


              </Collapse>
            </Card>

            <Divider />

              <Button onClick={()=> createNeurons()} >Add Neurons</Button>
              <Button onClick={()=> simRun()} >Run Sim</Button>
            </Card>

          </Col>
        </Row>
        <img style ={{ width: '200px', height: '50px', paddingRight: '10px' }} src={amritalogo} alt="Amrita"/>
          <img style ={{ width: '200px', height: '50px'}} src={vlablogo} alt="Amrita"/>
        </Card>
      </Grid>

      

      {/* <AdexTensor /> */}


    </div>
  );
}

export default App;
